module.exports = __webpack_public_path__ + "static/media/tree.21692e7c.svg";